import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { TokenService } from '../../services/token/token.service';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private tokenService = inject(TokenService);


  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.method == 'PUT' || request.method == 'GET') {
      return next.handle(request);
    }
    const EntityToken = this.tokenService.getToken();
    const headers = request.headers.set(
      'Authorization',
      `Bearer ${EntityToken}`,
    );
    const authReq = request.clone({ headers });
    return next.handle(authReq);
  }
}
